import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6 grid grid-cols-1 gap-4 lg:grid-cols-2" }

import LeadsReport from '@/components/reports/LeadsReport.vue'
import SignupSourceCard from '@/components/reports/SignupSourceCard.vue'
import { useLeadCaptureReveal } from '@/composables/useLeadCaptureReveal'


export default {
  __name: 'LeadCaptureReport',
  setup(__props) {

useLeadCaptureReveal()

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(LeadsReport, {
    title: "Lead capture page",
    endpoint: "lead_capture_page/report",
    "download-type": "lead_capture_page_leads",
    description: "Signups from your lead capture page and the orders they placed.",
    "empty-text": "No signups from your lead capture page in this date range yet.",
    wording: { date: 'Signed up', plural: 'signups', verb: 'signed up' },
    tiles: ['signups', 'new_vs_existing', 'paid_orders', 'revenue', 'conversion'],
    statuses: ['paid', 'no_order']
  }, {
    highlights: _withCtx(({ current, prior, change }) => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-3 text-sm font-semibold text-gray-900" }, "Where they signed up", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SignupSourceCard, {
          "data-source": "page",
          label: "Total hosted page signups",
          caption: "Your hosted signup page",
          value: String(current.source?.page ?? 0),
          delta: change(current.source?.page, prior.source?.page),
          rows: [
            { key: 'qr', label: 'Via QR code', value: String(current.via?.qr ?? 0) },
            { key: 'link', label: 'Via link', value: String(current.via?.link ?? 0) }
          ]
        }, null, 8, ["value", "delta", "rows"]),
        _createVNode(SignupSourceCard, {
          "data-source": "embed",
          label: "Total embedded form signups",
          caption: "The form embedded on your own website",
          value: String(current.source?.embed ?? 0),
          delta: change(current.source?.embed, prior.source?.embed),
          "empty-text": "An embedded form has no QR code or link to arrive by."
        }, null, 8, ["value", "delta"])
      ])
    ]),
    _: 1
  }))
}
}

}